module.exports = __webpack_public_path__ + "img/服务流程9.77966283.png";